import { faIR } from 'date-fns-jalali/locale';

const localize = {
  ordinalNumber: (n: number) => `${n}م`,

  era: (e: number) => ['قبل از میلاد', 'بعد از میلاد'][e],

  quarter: (q: string) => `فصل ${q}`,

  month: (m: number) =>
    ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'][m],

  day: (d: number) => ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'][d],

  dayPeriod: (p: number) =>
    ({
      am: 'ق.ظ',
      pm: 'ب.ظ',
      morning: 'صبح',
      afternoon: 'عصر',
      evening: 'عصر',
      night: 'شب',
      midnight: 'شب',
      noon: 'ظهر',
    }[p] ?? p),
};

export const local = {
  ...faIR,
  localize: {
    ...faIR.localize,
    ...localize,
  },
};

export const getDayPeriod = (date: Date) => {
  const h = date.getHours();

  if (h < 5) return 'بامداد';
  if (h < 12) return 'صبح';
  if (h < 15) return 'ظهر';
  if (h < 18) return 'بعدازظهر';
  if (h < 21) return 'عصر';
  return 'شب';
};
